export enum BackgroundMusicState {
  UNLOADED = 0,
  LOADED = 1,
  PLAYING = 2,
  ENDED =  4
}